import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import mapicon from "../../img/blue.png";
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
//import { getBusinesses } from "../../actions/advertiseActions";

const posobj = { lat: 40.485, lng: -106.8317 };

const GoogleMapExample = withGoogleMap(props => (

  <GoogleMap ref={props.onMapLoad} defaultCenter={props['ipo']}
    defaultZoom={props['zoom']}
    // onZoomChanged={props['onZoomChanged']}
    // onZoomChanged={props.onZoomChanged.bind(this)}
    // onDomReady={props['onDomReady']}
    onMapLoad={this.handleMapLoaded}
    onIdle={props['onIdle']}
    onShowDetailsClick={props['onShowDetailsClick']}
  // onLoad={map => {
  //   this.setState({ map: map });
  //   console.log('map loaded');
  // }}
  >
    {
      props.markers.map((marker, index) => (
        <Marker
          key={index}
          position={{ lat: marker.lat, lng: marker.lng }}
          onClick={props.onMarkerClick.bind(this, marker.id)}
          icon={mapicon}
        >
          {marker.show && (
            <InfoWindow onCloseClick={props.onCloseClick.bind(this, marker.id)}>
              <div>
                <div className="marker-text">
                  <b>{marker.name}</b>
                </div>
                <div className="marker-text">{marker.id}</div>
                <div className="marker-text">{marker.title}</div>
                <div className="marker-text">{marker.city}</div>
                {/* <a href="#" onClick={props.onShowDetailsClick.bind(this, marker.id)}>details</a> */}
                <a href="#" onClick={(e) => props.onShowDetailsClick(e, marker.id)}>details</a>

              </div>
            </InfoWindow>
          )}
        </Marker>
      ))
    }
  </GoogleMap >
));
//<th value={column} onClick={() => this.handleSort(column)}>{column}</th>
/*
const Map = ({ center, zoom }) => {

  function handleZoomChanged() {
    console.log(this.getZoom()) //this refers to Google Map instance
  }


  return (
    <GoogleMap defaultZoom={zoom} defaultCenter={center} onZoomChanged={handleZoomChanged} >
      <Marker position={center} />
    </GoogleMap>
  );
};
*/
class DealsMap extends Component {
  constructor(props) {
    super(props);
    //  console.log('dm prop deals', props.workdeals);
    this.mapRef = React.createRef();
    this.state = {
      curmarkerid: "",
      markers: [],
      map: null,
      deals: props.workdeals,
      bounds: null
    };
    //console.log(props);
    // console.log("Dashboard props", props);
    let lat = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleShowDetailsClick = this.handleShowDetailsClick.bind(this);
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    // this.handleZoomChanged = this.handleZoomChanged.bind(this);
  }

  componentDidMount() {

    //  console.log('component did mount props deals', this.props.workdeals)

    this.buildMarkers(this.props.workdeals);


    //let link = "/api/business/businesses";



  }

  // componentWillReceiveProps(nextProps) {

  //   if (this.props.workdeals !== nextProps.workdeals) {
  //     //console.log('we are rendering deals in cwrp');
  //     //console.log('this props', this.props);
  //     //console.log('next props', nextProps);

  //     this.buildMarkers(nextProps.workdeals);
  //   }

  // }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if ((this.props.workdeals) !== (prevProps.workdeals)) {
      this.buildMarkers(this.props.workdeals);
    }

  }

  buildMarkers = (deals) => {
    // console.log('build markers deals', deals);
    const bounds = new window.google.maps.LatLngBounds();
    let mary = [];
    let onepos = {};
    deals.forEach(deal => {
      let mo = {};
      let pos = {};
      mo['lat'] = deal['latitude'];
      mo['lng'] = deal['longitude'];
      pos['lat'] = deal['latitude'];
      pos['lng'] = deal['longitude'];
      mo['name'] = deal['name'];
      mo['id'] = deal['id'];
      mo['show'] = false;
      mo['title'] = deal.accommodations['title'];
      mo['city'] = deal['city'];
      mo['company'] = deal['company_id'];
      bounds.extend(pos);
      onepos = pos;
      mary.push(mo);
    })
    // console.log(mo);
    this.setState({ markers: mary, bounds: bounds });
    // console.log('just set bounds', bounds);
    if (this.state.map) {
      if (mary.length > 1) {
        this.state.map.fitBounds(bounds);
      } else {
        this.state.map.panTo(onepos);
        //this.state.map.setZoom(6);
      }
    }
  }

  // handleClick(event) {
  //   //this.setState({ [e.target.name]: e.target.value });
  //   let lat = event.latLng.lat();
  //   let lng = event.latLng.lng();
  //   //console.log(lat + " " + lng);
  //   this.props.handleMapClick(lat, lng);
  // }

  handleClick(e) {
    console.log("hc e", e);
    e.preventDefault();
  }
  handleCloseClick(bizid) {
    //console.log("handleCloseClick e", bizid);
    // e.preventDefault();
    let smarkers = this.state.markers;
    smarkers.map((marker, index) => {
      if (marker.id === bizid) {
        marker.show = false;
      }
    });

    this.setState({ markers: smarkers });
  }

  handleMarkerClick(bizid) {
    //  console.log("hmc clicked ", bizid);
    // e.preventDefault();
    //this.setState({ [e.target.name]: e.target.value });
    // let lat = event.latLng.lat();
    // let lng = event.latLng.lng();
    let smarkers = this.state.markers;
    smarkers.map((marker, index) => {
      if (marker.id === bizid) {
        if (marker.show) {
          marker.show = false;
        } else {
          marker.show = true;
        }
      }
    });

    this.setState({ markers: smarkers });

    //console.log("marker clicked index ", bizid);
    // this.props.handleMapClick(lat, lng);
  }
  /*
    onDomReady = () => {
      console.log('dom is ready');
    }
    handlePositionChanged = () => {
      console.log('dom is onPositionChanged');
    }
    handleZoomChanged = (map) => {
      // console.log('dom is handleZoomChanged', this.state.map.getZoom());
  
    }
  */

  handleMapLoaded = (map) => {
    // console.log('dom is handleMapLoaded');
    if (map) {
      // console.log('zl', map.getZoom());
      map.fitBounds(this.state.bounds);
      // console.log('just fit founds', this.state.bounds);
      this.setState({ map: map });
      // this.addListeners(map);
    }
  }

  /*
  addListeners = (map) => {
    // console.log('we are adding listeners', map);
    window.google.maps.event.addListener(map, 'idle', function () {
      //  console.log('zoom changed per the listener');
      // LD_FILTER.performFiltering();
      // LD_MAP.createClusters();

    });
  }
*/
  handleIdle = () => {
    // console.log('dom is handleIdle');
    let map = this.state.map;
    let markers = this.state.markers;
    var coordinates = map.getBounds();
    //  console.log(coordinates);
    let viewableids = [];
    markers.forEach(m => {
      let divid = 'ddid-' + m.id;
      let obj = document.getElementById(divid);
      if (obj) { // should not need this
        var placement = new window.google.maps.LatLng(m['lat'], m['lng']);
        if (coordinates.contains(placement)) {
          obj.style.display = 'block';
          //   viewableids.push(m['id'])
        } else {
          obj.style.display = 'none';
        }
      }
    })
    // console.log('viewableids', viewableids);
    // viewableids.forEach(id => {
    //   let divid = 'ddid-' + id;
    //   let obj = document.getElementById(divid);
    //   obj.style.display = 'none';
    // })

  }
  //handleChange = param => e => {
  handleShowDetailsClick = (e, id) => {
    e.preventDefault();
    // handleShowDetailsClick = (id) => e => {
    // console.log('handle link click', id);
    this.props.showDetailsFromMap(e, id);
  }

  /*
  google.maps.event.addListener(LD_MAP.g_map,'idle',function() {
      var map =  LD_MAP.g_map;
      var allmarkers = LD_MAP.g_markersary;
      var coordinates = map.getBounds();
      var numdeals = 0;

      $.each(allmarkers,function(i,m){
        var placement = new google.maps.LatLng(m['lat'],m['lng'] );
        var id = m['propid'];
        var divstr = '#dealdiv_' + id;
        var obj = $(divstr);
        //if( coordinates.contains(placement) && m.getVisible() ) {
          if( m.getVisible() && coordinates.contains(placement)  ) {
          obj.show();
          numdeals += m.propobj['dealsary'].length; 
        } else {
          obj.hide();
        }
      });
      //console.log('numdeals idle =' + numdeals);
      $('#numdeals').html(numdeals);
    	
    });
    */
  // handleZoomChanged(map) {
  //   console.log('dom is handleZoomChanged');
  //   console.log('zl', map.getZoom());
  // }

  render() {
    //console.log("maplookup props", this.props);
    // console.log("mapbusines render");

    let posobj = { lat: 40.0150, lng: -105.2705 };  //bldr

    let themarkers = this.state.markers;

    let izoom = 6;
    return (
      <div>


        {/* <div className="row">
          <div className="col-md-12 "> */}
        <GoogleMapExample
          containerElement={
            <div style={{ height: "715px", width: "100%" }} />
          }

          mapElement={<div style={{ height: `100%` }} />}
          markers={themarkers}
          onMarkerClick={this.handleMarkerClick}
          onCloseClick={this.handleCloseClick}
          //onDomReady={this.onDomReady}
          //onPositionChanged={this.handlePositionChanged}
          //onZoomChanged={this.handleZoomChanged}
          onMapLoad={this.handleMapLoaded}
          onIdle={this.handleIdle}
          onShowDetailsClick={this.handleShowDetailsClick}

          ipo={posobj}
          zoom={izoom}
        />

      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  deals: state.deals,
  // advertise: state.advertise
});
// the state.auth above comes from rootReducer in index.js in reducers.

export default connect(
  mapStateToProps,
  {}
)(DealsMap);



// WEBPACK FOOTER //
// ./src/components/deals/DealsMap.js